import styled from 'styled-components'

export const Header = styled.header`
padding: 20px 30px;
display: flex;
flex-direction: column;
gap: 20px;
`